import {useEffect} from "react";

interface GetUrlMessageData {
  type: "GET_URL";
}

interface UrlResponseMessage {
  type: "URL_RESPONSE";
  url: string;
}

export const useFlexUrlListener = () => {
  useEffect(() => {
    const handler = (event: MessageEvent<GetUrlMessageData>) => {
      if (event.data?.type === "GET_URL") {
        const response: UrlResponseMessage = {type: "URL_RESPONSE", url: window.location.href};
        event.source?.postMessage(response, {targetOrigin: "*"});
      }
    };
    window.addEventListener("message", handler);
    return () => window.removeEventListener("message", handler);
  }, []);
};
